import "./virtualized-scroll-list.scss";
import throttle from "lodash/throttle";

window.app.directive("virtualizedScrollList", [
  "$compile",
  function($compile) {
    return {
      restrict: "E",
      scope: {
        scrollerClass: "@",
        rowHeight: "@",
        rows: "&",
        bufferSize: "@"
      },
      compile: function(ele, attrs) {
        var childHtml = ele.html();
        ele.html("");
        const templ = require("./virtualized-scroll-list.html");

        return function($scope, elem) {
          $scope.outer = $scope.$parent;

          const outer = angular.element(templ);
          outer.attr(
            "class",
            "virtualized-scroll-list " + $scope.scrollerClass
          );

          const mid = outer.children();
          const inner = mid.children();
          inner.attr("style", "top: {{rowHeight * (offset + $index)}}px");
          inner.append(childHtml);

          $scope.getItemsToRender = () => {
            $scope.offset = 0;
            const { scrollTop = 0, rowHeight = 10, bufferSize = 3 } = $scope;
            const rows = $scope.rows();
            if (!rows || !rows.length) return [];
            mid[0].style.height = rows.length * rowHeight + "px";
            const height = outer[0].clientHeight;
            const start = Math.max(
              0,
              Math.floor(scrollTop / rowHeight - bufferSize)
            );
            const end = Math.min(
              rows.length,
              Math.ceil(start + height / rowHeight + 2 * bufferSize)
            );
            $scope.offset = start;
            return rows.slice(start, end);
          };

          $compile(outer)($scope);
          elem.append(outer);

          const handleScroll = throttle(() => {
            $scope.$apply(() => {
              $scope.scrollTop = outer[0].scrollTop;
            });
          }, 100);
          outer.on("scroll", handleScroll);
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/virtualized-scroll-list/virtualized-scroll-list.js